import { style } from '@vanilla-extract/css'

const card = style({
  backgroundColor: '#EAEBE0',
  borderRadius: '16px',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '2px',
})

const heading = style({
  fontSize: '15px',
  fontWeight: '700',
  lineHeight: '1.5',
})

const description = style({
  fontSize: '13px',
  lineHeight: '1.5',
  letterSpacing: '0.02em',
})

export const styles = {
  card,
  heading,
  description,
}
